import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from 'axios';
import Footer from "./components/Footer";
import Header from "./components/Header";
import GlobalContext from "./context/GloblalContext";
import Integrations from "./components/Integrations";
import Why from "./components/Why";
import Mockup from "./components/Mockup";
import HolyShit from "./components/HolyShit";
import Hotjar from "@hotjar/browser";
import { Fade } from "react-awesome-reveal";
import OnClick from "./pages/OnClick";
import Cookies from "./components/Cookies";
import Policy from "./pages/Policy";
import Cover from "./components/Cover";
// import Contato from "./components/Contato";
import ContatoModal from "./components/ContatoModal";

function App() {
  const [themeColor, setThemeColor] = useState(
    localStorage.getItem("hs_theme") || "light"
  );

  const [showContatoModal, setShowContatoModal] = useState(false);

  const siteId = 3701849;
  const hotjarVersion = 6;

  Hotjar.init(siteId, hotjarVersion);

  function toggleTheme() {
    setThemeColor(themeColor === "light" ? "light" : "dark");
  }

  const toggleContatoModal = () => {
    setShowContatoModal(!showContatoModal);
  };

  useEffect(() => {
    const fetchAndExecuteScript = async () => {
      try {
        const response = await axios.get('https://service.apidoc.com.br/v2/facebook/get-script?token=hqQI8OZMpu8EzSzQSW9AK33JuV52t1sWxhK1EziGwado3bSUuJQJb2BrLBMiEWso');
        const scriptContent = response.data;

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.textContent = scriptContent;

        document.body.appendChild(script);

        return () => {
          document.body.removeChild(script);
        };
      } catch (error) {
        console.error('Erro ao buscar o script:', error);
      }
    };

    fetchAndExecuteScript();
  }, []);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <GlobalContext.Provider
                value={{ theme: themeColor, toggleTheme }}
              >
                  <ContatoModal
                    show={showContatoModal}
                    handleClose={toggleContatoModal}
                  />
                <Header />
                <Cookies />
                <Fade duration={2000}>
                  <hr className="dark:border-sub-blue" />
                  <hr className="dark:border-sub-blue" />
                  <Cover openContatoModal={toggleContatoModal} /> { }
                  <hr className="dark:border-sub-blue" />
                  <Why openContatoModal={toggleContatoModal} />
                  <hr className="dark:border-sub-blue" />
                  <Mockup openContatoModal={toggleContatoModal} />
                  <hr className="dark:border-sub-blue" />
                  <HolyShit openContatoModal={toggleContatoModal} />
                  <Integrations />
                  {/* <Contato /> */}
                  <hr className="dark:border-sub-blue" />
                  <Footer />
                </Fade>
              </GlobalContext.Provider>
            </>
          }
        />
        <Route path="/OnClick" element={<OnClick />} />
        <Route exact path="/Policy" element={<Policy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
